import React, { useState } from 'react'
import { t } from '@lingui/core/macro'
import styles from './CopyButton.module.css'

const CopyButton = ({text}: {text: string}) => {
    const [isCopied, setIsCopied] = useState(false)

    const handleCopyCode = async () => {
        try {
            await navigator.clipboard.writeText(text)
            setIsCopied(true)
            setTimeout(() => setIsCopied(false), 2000)
        } catch (error) {
            console.error('Failed to copy:', error)
        }
    }

    return (
        <button onClick={handleCopyCode}  className={styles.copyButton}>
            {isCopied ? t`✓ Скопировано` : t`Скопировать код`}
        </button>
    )
}

export default CopyButton
